if (!customElements.get('card-add-to-cart-form')) {
  customElements.define(
    'card-add-to-cart-form',
    class CardAddToCartForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.quantityInput = this.querySelector('.quantity__input');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      clampQuantity() {
        if (!this.quantityInput) return;

        let quantity = parseInt(this.quantityInput.value, 10);
        if (isNaN(quantity) || quantity < 1) quantity = 1;

        if (this.quantityInput.max !== '') {
          quantity = Math.min(quantity, parseInt(this.quantityInput.max, 10));
        }
        if (this.quantityInput.min !== '') {
          quantity = Math.max(quantity, parseInt(this.quantityInput.min, 10));
        }

        this.quantityInput.value = quantity;
      }

      showAddedFeedback() {
        const addedMessage = this.submitButton.querySelector('.added-message');
        const defaultLabel = this.submitButton.querySelector('span:not(.sold-out-message):not(.added-message)');
        if (!addedMessage || !defaultLabel) return;

        defaultLabel.classList.add('hidden');
        addedMessage.classList.remove('hidden');
        clearTimeout(this.addedFeedbackTimeout);
        this.addedFeedbackTimeout = setTimeout(() => {
          addedMessage.classList.add('hidden');
          defaultLabel.classList.remove('hidden');
        }, 2000);
      }

      resetQuantity() {
        if (!this.quantityInput || this.quantityInput.disabled) return;
        this.quantityInput.value = this.quantityInput.min || 1;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.clampQuantity();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append('sections', 'cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'card-add-to-cart-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (response.sections) {
              refreshCartIconBubble(response.sections['cart-icon-bubble']);
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'card-add-to-cart-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.showAddedFeedback();
            this.resetQuantity();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
